import * as S from './styles'
import Manutencao from 'src/assets/lotties/95297-computer.json'

import Lottie from 'lottie-react'

const MaintenancePage = () => {
  return (
    <S.ContainerManutencao>
      <Lottie animationData={Manutencao} autoplay={true} loop={true} />
      <S.Text>
        <span>Aguarde ...</span>
        <br />
        Estamos melhorando nossos sistemas e sua experiência. Volte mais tarde.
      </S.Text>
    </S.ContainerManutencao>
  )
}

export { MaintenancePage }
